import React from 'react';
export const ObjectionSection = () => {
  return <section className="w-full py-16" data-id="element-187">
      <div className="max-w-5xl mx-auto px-4" data-id="element-188">
        <div className="flex flex-col md:flex-row" data-id="element-189">
          <div className="w-full md:w-1/2 bg-gray-900 text-white p-8 md:rounded-l-lg" data-id="element-190">
            <h3 className="text-2xl font-bold mb-6" data-id="element-191">
              Co jeśli to nie zadziała?
            </h3>
            <ul className="space-y-4" data-id="element-192">
              <li className="flex items-start" data-id="element-193">
                <span className="text-red-500 mr-2" data-id="element-194">•</span>
                <span data-id="element-195">Co jeśli on jest inny?</span>
              </li>
              <li className="flex items-start" data-id="element-196">
                <span className="text-red-500 mr-2" data-id="element-197">•</span>
                <span data-id="element-198">Co jeśli już jest za późno?</span>
              </li>
              <li className="flex items-start" data-id="element-199">
                <span className="text-red-500 mr-2" data-id="element-200">•</span>
                <span data-id="element-201">Co jeśli zmarnuję pieniądze?</span>
              </li>
            </ul>
          </div>
          <div className="w-full md:w-1/2 bg-white border-2 border-gray-900 p-8 md:rounded-r-lg" data-id="element-202">
            <h3 className="text-2xl font-bold mb-6" data-id="element-203">A co jeśli ZADZIAŁA?</h3>
            <ul className="space-y-4" data-id="element-204">
              <li className="flex items-start" data-id="element-205">
                <span className="text-green-500 mr-2" data-id="element-206">•</span>
                <span data-id="element-207">Co jeśli znów będzie na Ciebie patrzył jak kiedyś?</span>
              </li>
              <li className="flex items-start" data-id="element-208">
                <span className="text-green-500 mr-2" data-id="element-209">•</span>
                <span data-id="element-210">Co jeśli znów poczujesz się kochana?</span>
              </li>
              <li className="flex items-start" data-id="element-211">
                <span className="text-green-500 mr-2" data-id="element-212">•</span>
                <span data-id="element-213">Co jeśli uratujecie wspólne lata?</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="text-center mt-10" data-id="element-214">
          <p className="text-xl font-serif italic" data-id="element-215">
            "Ta jedna decyzja może uratować wszystko"
          </p>
        </div>
      </div>
    </section>;
};